import { render, staticRenderFns } from "./hotkeys-modal.vue?vue&type=template&id=24e3cc07&"
import script from "./hotkeys-modal.vue?vue&type=script&lang=js&"
export * from "./hotkeys-modal.vue?vue&type=script&lang=js&"
import style0 from "./hotkeys-modal.vue?vue&type=style&index=0&id=24e3cc07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports